import { cn } from '../../lib/utils';

const alertVariants = {
  default: 'bg-background text-foreground border-border',
  destructive: 'bg-destructive/10 border-destructive/50 text-destructive',
  success: 'bg-success/10 border-success/50 text-success',
  warning: 'bg-warning/10 border-warning/50 text-warning',
  info: 'bg-primary/10 border-primary/50 text-primary',
};

const Alert = ({ className, variant = 'default', children, ...props }) => {
  return (
    <div
      role="alert"
      className={cn(
        'relative w-full rounded-lg border p-4',
        alertVariants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const AlertTitle = ({ className, children, ...props }) => {
  return (
    <h5
      className={cn('mb-1 font-medium leading-none tracking-tight', className)}
      {...props}
    >
      {children}
    </h5>
  );
};

const AlertDescription = ({ className, children, ...props }) => {
  return (
    <div
      className={cn('text-sm [&_p]:leading-relaxed', className)}
      {...props}
    >
      {children}
    </div>
  );
};

export { Alert, AlertTitle, AlertDescription };
